module.exports = __webpack_public_path__ + "img/55.6667c8c6.png";